import { Box } from '@mui/material';
import { Nav } from 'components/navigation/Nav';

export const MainLayout = ({ children }) => {
  return (
    <Box display={'flex'} height={'100vh'}>
      <Nav />
      <Box flex={1} overflow={'auto'}>
        {children}
      </Box>
    </Box>
  );
};
